import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/app/globals.css'
import '@/app/soft-ui-v2.css'
import '@/app/soundscape.css'
import { refreshWebAppOnLaunch } from '@/services/web-update'

window.addEventListener('vite:preloadError', event => {
  event.preventDefault()
  window.location.reload()
})

void refreshWebAppOnLaunch()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
